export const ABOUT_ME_HASH = 'about-me';
export const EDUCATION_HASH = 'education';
export const WORK_HASH = 'work-experience';
export const SKILLS_HASH = 'skills';
export const TESTIMONIALS_HASH = 'testimonials';